import React from 'react';

/** Default: Microsoft Forms embed (Send → embed, copy iframe src). Override via .env if the form URL changes. */
const DEFAULT_MEMBER_REGISTRATION_EMBED_URL =
    'https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAa__Wm3EKlURE01REw0WVZWRlVDU1ZYTExBUlc5UlBVNS4u&embed=true';

const MemberRegistration = () => {
    const embedUrl =
        process.env.REACT_APP_CORTEX_MEMBER_REGISTRATION_FORM_EMBED_URL || DEFAULT_MEMBER_REGISTRATION_EMBED_URL;

    return (
        <div className="bg-gray-50">
            <iframe
                title="CORTEX member registration"
                src={embedUrl}
                className="w-full border-0 block max-w-full h-[calc(100vh-4rem)]"
                style={{ border: 'none' }}
                allowFullScreen
            />
        </div>
    );
};

export default MemberRegistration;
